import {PropertyType} from 'common/report/constants';
import {DateRange} from 'common/widgets/date-range-picker/models/date-range';
import {DateRangeType} from 'common/widgets/date-range-picker/models/types';
import type {CohortSegment} from 'common/widgets/query-block/segment-menu/types';

export enum ListQuantifier {
  Any = `any`,
  All = `all`,
}

export const PropertyTypeSet = new Set(Object.values(PropertyType));

// TODO(mack): This is model representation. These are also used as the display names
// in the UI. There should be a mapping from model representation to display names as
// the model shouldn't change, but the display names can.

export enum StringOperator {
  Contains = `contains`,
  DoesNotContain = `does not contain`,
  DoesNotEqual = `does not equal`,
  Equals = `equals`,
  NotSet = `is not set`,
  Set = `is set`,
}

export enum ObjectOperator {
  Equals = `equals`,
  Set = `is set`,
}

export enum NumberOperator {
  AtLeast = `is at least`,
  Between = `is between`,
  NotBetween = `is not between`,
  EqualTo = `is equal to`,
  NotEqualTo = `is not equal to`,
  GreaterThan = `is greater than`,
  LessThan = `is less than`,
  AtMost = `is at most`,
}

export enum ListOperator {
  Contains = `contains`,
  DoesNotContain = `does not contain`,
}

export enum BooleanOperator {
  True = `true`,
  False = `false`,
}

export enum CohortOperator {
  In = `in`,
  NotIn = `not in`,
}

export const CohortOperatorListMap = {
  [CohortOperator.In]: ListOperator.Contains,
  [CohortOperator.NotIn]: ListOperator.DoesNotContain,
};

export enum LogicalOperator {
  And = `and`,
  Not = `not`,
  Or = `or`,
}

export enum NthTimeOperator {
  FirstTime = `nth time`,
}

export type FilterOperator =
  | StringOperator
  | NumberOperator
  | DateRangeType
  | ListOperator
  | BooleanOperator
  | ObjectOperator
  | NthTimeOperator;

export type FilterOperand = string | boolean | number | Partial<DateRange> | CohortSegment;
export type FilterValue = FilterOperand | FilterOperand[];

export enum DisplayContext {
  Cohorts = `cohorts`,
  CustomEvent = `custom_event`,
  Default = `default`,
  Insights = `insights`,
  Signal = `signal`,
}
